import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    newBadge: 'NEW',
  },
  ru: {
    newBadge: 'НОВЫЙ',
  },
  uz: {
    newBadge: 'YANGI',
  },
  fa: {
    newBadge: 'جدید',
  },
});
